import axiosIns from 'utils/axios'
let epmcore ='EPM-CORE-SERVICE'


// 获取变更列表
export function pageMyTableDemand (params) {
    return axiosIns({
      url: `/api/pc/employee/pageRelateDemand`,
      owner: epmcore,
      method: 'get',
      params
    })
}

export function pageProjectDemand (params) {
  return axiosIns({
    url: `/api/pc/employee/pageRelateProject`,
    owner: epmcore,
    method: 'get',
    params
  })
}

export function projectMemberVerify (params) {
  return axiosIns({
    url: `/api/pc/projectMemberVerify/page`,
    owner: epmcore,
    method: 'get',
    params
  })
}

export function projectMemberVerifyagree (id) {
  return axiosIns({
    url: `/api/pc/projectMemberVerify/agree/${id}`,
    owner: epmcore,
    method: 'put'
  })
}

export function projectMemberVerifyreject (data) {
  return axiosIns({
    url: `/api/pc/projectMemberVerify/reject`,
    owner: epmcore,
    method: 'put',
    data
  })
}

export function batchSetEmployeeRelateDemandStatus (data) {
  return axiosIns({
    url: `/api/pc/employee/batchSetEmployeeRelateDemandStatus`,
    owner: epmcore,
    method: 'put',
    data
  })
}

export function getJoinCompanyTime (employeeId) {
  return axiosIns({
    url: `/api/pc/company/getJoinCompanyTime/${employeeId}`,
    owner: epmcore,
    method: 'get'
  })
}

//更新个人设置
export function updatePersonalSetting (data) {
  return axiosIns({
    url: `/api/pc/employee/updatePersonalSetting`,
    owner: epmcore,
    method: 'put',
    data
  })
}

//获取个人设置
export function getPersonalSetting () {
  return axiosIns({
    url: `/api/pc/employee/getPersonalSetting`,
    owner: epmcore,
    method: 'get',
  })
}





// WEBPACK FOOTER //
// ./src/views/my-workbench/api.js